/**
 * @Author xyguo
 * @description 新开业培训
 * @Date 2021/3/11
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Form, message, Popconfirm, Spin, Upload} from "antd";
import { WizTableForm } from '@/containers/common';
import RequirementConfigForm from './requirementConfigForm';
const offlineProgramConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } });
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole"} })
const trainSite = WizTableForm.Config.trainSite()
let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip } = component_tool;
let Item = Form.Item;
let Option = WizSelect.Option;
let {Session} = utils_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

class requirementConfigDetail extends WizContainer {

  componentName = 'requirementConfigDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/requirementConfig/requirementConfigList/requirementConfigUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('requirementConfigDetailRecord', initialValue)
      } else {
        initialValue = Session.get('requirementConfigDetailRecord') || {};
      }
    }
    this.state = {
      
    };
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    const {history} = this.props;
    if (this.initialValue && this.initialValue.id){
      this.getRequirementInfo();
    }
  }

  propsAndStateOnChange = {
    addRequirementConfig: this._addRequirementConfigOver.bind(this),
    updateRequirementConfig: this._updateRequirementConfigOver.bind(this),
    requirementConfigInfo:this._getRequirementInfoOver.bind(this),
  };

  /**
   * 将查询到的新开业培训加载到记录中
   */
   _getRequirementInfoOver(nextProps, nextState) {
    let requirementConfigInfo = nextProps.requirementConfigInfo.data;
    const {id} = requirementConfigInfo;
    if (nextProps.requirementConfigInfo.code == 1 && id && id>0) {
      this.initialValue.requirementContents = requirementConfigInfo.requirementContents;
    }else {
      this.initialValue.id = null;
    }
    return true;
  }

  /**
   * 
   */
  _addRequirementConfigOver(nextProps, nextState) {
    if (nextProps.addRequirementConfig.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/requirementConfig/requirementConfigList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addRequirementConfig.msg);
    }
    return true;
  }

  /**
   * 线下培训班级修改成功返回原页面，失败弹出提示
   */
  _updateRequirementConfigOver(nextProps, nextState) {
    if (nextProps.updateRequirementConfig.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/requirementConfig/requirementConfigList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateRequirementConfig.msg);
    }
    return true;
  }

  /**获取新开业培训数据 */
  getRequirementInfo() {
    this.doAction({
      path: 'requirementConfig/selectOneById',
      payload: {
        key: 'requirementConfig@selectOneById',
        apiParams: {
          id: this.initialValue.id,
        }
      }
    });
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    if(this.initialValue.id){
      fieldsValue.id = this.initialValue.id;
    }
    return fieldsValue;
  };

  /**
   * 保存/更新 
   * @param values
   * @private
   */
  _saveRequirement(values) {
    const {history} = this.props;
    let apiPath = "requirementConfig/add";
    let payloadKey = "requirementConfig@add";
    if (history.location && history.location.pathname === '/requirementConfig/requirementConfigList/requirementConfigUpd') {
      apiPath = "requirementConfig/update";
      payloadKey = "requirementConfig@update";
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  };

  _render() {
       return (
         <>
           <WizCard>
           <WizSpin tip={"加载中"} spinning={this.props.requirementConfigLoading }>
                       <RequirementConfigForm key = {this.state.ruleId} submit={(v) => { this._saveRequirement(v) }} data={this.initialValue}/>
                   </WizSpin>
           </WizCard>
         </>
       );
     }
}

const mapStateToProps = (state, ownProps) => {
  const {requirementConfig} = state;
  const addRequirementConfig = modelUtils.getModelEntity(requirementConfig, "requirementConfig@add");
  const updateRequirementConfig = modelUtils.getModelEntity(requirementConfig, "requirementConfig@update");
  const requirementConfigInfo = modelUtils.getModelEntity(requirementConfig, "requirementConfig@selectOneById");
  const load = modelUtils.getLoadingState(state, ['requirementConfig']);
  return {
    addRequirementConfig: addRequirementConfig,
    updateRequirementConfig: updateRequirementConfig,
    requirementConfigInfo: requirementConfigInfo,
    ...load
  }
};

export default connect(mapStateToProps)(requirementConfigDetail);
